var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-snackbar',{attrs:{"timeout":"4000","value":_vm.message,"right":"","top":"","color":_vm.getColor()}},[_c('span',{staticClass:"body white--text"},[_c('v-icon',{staticClass:"mr-2 white--text"},[_vm._v(_vm._s(_vm.getIcon()))]),_vm._v(_vm._s(_vm.getText()))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }